<template>
  <v-overlay
    :value="loading"
    :absolute="absolute"
    z-index="100">
    <v-sheet
      color="transparent"
      min-width="150"
      width="200"
      class="text-center">
      <v-progress-linear
        v-if="mode === 'linear'"
        :value="value"
        background-color="background"
        height="16"
        rounded>
        <span class="secondary--text text-validation">{{ Math.round(value) }}%</span>
      </v-progress-linear>
      <v-progress-circular
        v-else
        indeterminate
        size="64" />
    </v-sheet>
  </v-overlay>
</template>

<script>
export default {
  name: 'OverlayLoading',
  props: {
    mode: {
      type: String,
      default: 'circular',
      validator: (val) => ['circular', 'linear'].includes(val)
    },
    value: {
      type: Number,
      default: 0
    },
    loading: Boolean,
    absolute: Boolean
  }
}
</script>
